import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';

// Our API returns dates either in timestamps or in UTC

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

// the timezone on the user's machine
const guessedTimezone = dayjs.tz.guess();

// returns the date in the local timezone
export function formatDateWithLocalTimezone(
  date: string | number,
  format = 'MM/DD/YY',
) {
  const parsedDate = dayjs.utc(date).tz(guessedTimezone);
  if (!parsedDate.isValid()) {
    return null;
  }
  return parsedDate.format(format);
}

export function getLocalTimezoneAbbreviation() {
  const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
    timeZone: guessedTimezone,
  });

  const dateParts = dateTimeFormat.formatToParts(new Date());

  const timezone = dateParts.find(part => {
    return part.type === 'timeZoneName';
  });

  return timezone?.value || '';
}
